import { Component, inject } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';

import { AuthStore } from '../../../authentication/authStore';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { UserInfo } from '../../../../shared/ui/components/user-info/user-info';
import { BreadcrumbService } from '../../../services/breadcrumb-service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NzLayoutModule,
    NzMenuModule,
    NzAvatarModule,
    NzButtonModule,
    NzBreadCrumbModule,
    NzIconModule,
    UserInfo,
    RouterModule,
    CommonModule,
  ],
  templateUrl: './main-layout.html',
  styleUrls: ['./main-layout.scss'],
})
export class MainLayoutComponent {
  auth = inject(AuthStore);
  isCollapsed = false;
  router = inject(RouterOutlet);
  breadcrumbService = inject(BreadcrumbService);
  protected readonly date = new Date();

  ngOnInit() {
  }
}
